var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.484 10.757L3.575 6.493a.7.7 0 01.516-1.173h7.818a.7.7 0 01.516 1.173l-3.909 4.264a.7.7 0 01-1.032 0z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjQ4Mzk5IDEwLjc1N0wzLjU3NTI2IDYuNDkyOTVDMy4xNjM2OSA2LjA0Mzk3IDMuNDgyMTkgNS4zMTk5NSA0LjA5MTI2IDUuMzE5OTVIMTEuOTA4N0MxMi41MTc4IDUuMzE5OTUgMTIuODM2MyA2LjA0Mzk3IDEyLjQyNDcgNi40OTI5NUw4LjUxNjAxIDEwLjc1N0M4LjIzODU3IDExLjA1OTcgNy43NjE0MyAxMS4wNTk3IDcuNDgzOTkgMTAuNzU3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { Svg16 as ReactComponent };